import React from 'react';

function Customers() {
  const customerTypes = [
    {
      type: 'Homeowners',
      description: 'Private pond and lake maintenance',
      icon: '🏠',
    },
    {
      type: 'Developers',
      description: 'New construction water features',
      icon: '🏗️',
    },
    {
      type: 'Property Managers',
      description: 'Multi-property maintenance programs',
      icon: '🏢',
    },
    {
      type: 'CDDs',
      description: 'Community Development Districts',
      icon: '🏘️',
    },
    {
      type: 'Condos & HOAs',
      description: 'Shared community water features',
      icon: '🏬',
    },
    {
      type: 'Businesses',
      description: 'Commercial property maintenance',
      icon: '💼',
    },
  ];

  return (
    <section className="bg-slate-50 py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-900 text-center mb-4">
          Who We Work With
        </h2>
        <p className="text-xl text-brand-700 text-center mb-12 max-w-2xl mx-auto">
          Serving residential and commercial clients throughout Florida
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-5xl mx-auto">
          {customerTypes.map((customer, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-lg p-4 text-center border-2 border-brand-100 hover:border-water-400 transition-colors"
            >
              <div className="text-3xl mb-2">{customer.icon}</div>
              <h3 className="font-bold text-brand-900 text-sm md:text-base">
                {customer.type}
              </h3>
              <p className="text-slate-600 text-xs mt-1 hidden md:block">
                {customer.description}
              </p>
            </div>
          ))}
        </div>

        <p className="text-center text-brand-600 mt-8">
          No project is too big or too small. Contact us to discuss your needs.
        </p>
      </div>
    </section>
  );
}

export default Customers;
